import dayjs from 'dayjs';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { dateFormat } from './date-format';

export const getTime = (dateTime: Date, separator = '.'): string => {
  return dayjs
    .utc(dateTime)
    .local()
    .format(
      dateFormat({
        date: SpringConfigs.DT.longDate,
        separator: separator,
        time: SpringConfigs.DT.time,
        dateTimeSeparator: ' '
      }).replace('MMM', 'MM')
    );
};
